import { useMutation, useQueryClient } from '@tanstack/react-query';
import { packagesService, TrainerPackage } from '../services/packagesService';
import { trainerPackagesQueryKey } from '../queries/useGetTrainerPackages';

export interface SavePackagePayload {
  trainerId: string;
  packageData: Partial<TrainerPackage>;
  signal?: AbortSignal;
}

export function useSaveTrainerPackage() {
  const queryClient = useQueryClient();

  return useMutation<TrainerPackage, Error, SavePackagePayload>({
    mutationFn: async ({ trainerId, packageData, signal }) => {
      return packagesService.saveTrainerPackage(trainerId, packageData, signal);
    },
    onSuccess: (savedPackage, variables) => {
      const qKey = trainerPackagesQueryKey(variables.trainerId);

      // Hydrate query cache immediately
      queryClient.setQueryData<TrainerPackage[]>(qKey, (oldList = []) => {
        const index = oldList.findIndex((p) => p.id === savedPackage.id);
        if (index >= 0) {
          const next = [...oldList];
          next[index] = savedPackage;
          return next;
        }
        return [...oldList, savedPackage];
      });

      queryClient.invalidateQueries({ queryKey: qKey });
    },
  });
}
